import React from "react";
import ProductFreePairList from "../../components/event/ProductFreePairList";

const ProductFreePairsPage = () => {
    return <ProductFreePairList/>
}

export default ProductFreePairsPage;